import React, { useLayoutEffect, useRef } from 'react'
import styled from 'styled-components'
import FileStructure from './FileStructure'
import Social from '../Pages/Social'
import { BiChevronDown } from 'react-icons/bi'
import gsap from 'gsap'
import Projects from '../Pages/Projects'
import About from '../Pages/About'
import Contact from '../Pages/Contact'
import { motion, useScroll, useTransform } from 'framer-motion'
import HamBurg from '../Extra/HamBurg'

const Main = () => {

    const para = useRef();
    const heading = useRef();
    const homeDiv = useRef(null);

    useLayoutEffect(() => {

        const timeline = gsap.timeline()
        timeline.from(para.current, { opacity: 0, ease: "power1.inOut" })
    }, [])

    const { scrollYProgress } = useScroll({
        target: homeDiv.current,
        offset: ["start start", "center start"]
    })

    const scale = useTransform(scrollYProgress, [0, 0.2], [1, 0]);
    const opacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);

    return (
        <FileStructure>

            <HamBurg />

            <HomeDiv className="homeDiv" ref={homeDiv} >
                <motion.h1
                    style={{ scale, opacity }}
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                        ease: [0.65, 0, 0.35, 1],
                        duration: 1,
                        delay: 1
                    }}
                    className='heading mainHeading' id='headingMain' ref={heading} >Gagan
                </motion.h1>
                <motion.span
                    style={{ scale, opacity }}
                    className='spanDetail' ref={para}>
                    Front End | MERN Stack | Full Stack Developer
                </motion.span>

                <motion.div
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                        ease: [0.65, 0, 0.35, 1],
                        duration: 1,
                        delay: 1
                    }}
                    className='scroll'>
                    <BiChevronDown />
                </motion.div>
            </HomeDiv>
            <Social />

            <Cursor className="cursor"> <span> View Project </span> </Cursor>
            <About />
            <Projects />
            <Contact />

        </FileStructure>
    )
}

export default Main

const Cursor = styled.div``

const HomeDiv = styled.div`
    display: flex;
    height: 100vh;
    width: 100vw;
    justify-content: center;
    align-items:center;
    flex-direction: column;

    h1{
        font-family: var(--font1) !important;
        letter-spacing: 0.2rem;
        font-size: 15rem;
        font-weight: 800;
        position: relative;
    }
    
    span{
        position: relative;
        font-family: var(--font2);
        letter-spacing: 0.2rem;
        font-size: 1.5rem;
        font-weight: 800;
    }
`